export const recursiveFormData = (formData, jsonData, index = null) => {
  for (var key in jsonData) {
    let value = jsonData[key];

    if (index) {
      key = index + "[" + key + "]";
    }

    if (value instanceof File) {
      formData.append(key, value);
    } else if (typeof value === "object") {
      recursiveFormData(formData, value, key);
    } else if (typeof value === "boolean") {
      formData.append(key, value ? 1 : 0);
    } else {
      formData.append(key, value);
    }
  }
};

export const jsonToFormData = (jsonData) => {
  const formData = new FormData();
  recursiveFormData(formData, jsonData);
  return formData;
};

export const FORM = {
  jsonToFormData,
  config: {
    headers: {
      "content-type": "multipart/form-data",
    },
  },
};

export default jsonToFormData;
